<div [style.min-height]="minHeight()" class="image-container">
  <div [class]="isLoading() ? loadingContainerClass() : ''" [style.height]="height()" [style.width]="width()">
    <div *loading="isLoading(); class: loadingClass()"></div>

    <img
      #image
      (error)="onError()"
      (load)="onLoad()"
      [class]="[customClass(), 'image-component']"
      [src]="currentSrc()"
      [style.height]="isLoading() ? '0px' : height()"
      [style.opacity]="isLoading() ? '0' : '1'"
      [style.width]="isLoading() ? '0px' : width()"
      alt="image"
    />
  </div>
</div>
